import React from 'react';
import Seo, { faqSchema, localBusinessSchema } from '../../GlobalComp/Seo/Seo';
import Hero from './Sections/Hero/Hero';
import Services from './Sections/Services/Services';
import WhyChooseUs from './Sections/WhyChooseUs/WhyChooseUs';
import HowItWorks from './Sections/HowItWorks/HowItWorks';
import Review from './Sections/Review/Review';
import AreasServed from './Sections/AreasServed/AreasServed';
import Faq from './Sections/Faq/Faq';
import { FAQS } from '../../../data/faqs';
import { SITE } from '../../../data/siteConfig';

export default function Home() {
    return (
        <main>
            <Seo
                title="General Contractor & Remodeling in Boca Raton & South Florida | 561-FIX-HOME"
                description={`5-star rated general contractor, kitchen & bath remodeling and home renovation services in Boca Raton and South Florida. Licensed & insured. Call ${SITE.phone} or book online.`}
                path="/"
                jsonLd={[localBusinessSchema(), faqSchema(FAQS)]}
            />
            <Hero />
            <Services />
            <WhyChooseUs />
            <HowItWorks />
            <Review />
            <AreasServed />
            <Faq />
        </main>
    );
}
